// Routes for the QR-based database signup flow.
//
// /subscribe?db=<uuid>
//   Public landing page the QR code points at. Handles anonymous
//   signup (new subscription request) and redirects doctors/staff
//   to the right next step based on auth state.
//
// /join?db=<uuid>
//   Authenticated confirmation page for doctors to self-associate
//   with a database after scanning a QR.
const routes = [
  {
    // Public landing page for the QR code. Accessible by anyone
    // (anonymous, doctor, staff) — the component decides what to
    // render based on auth state. We intentionally do NOT use
    // `noAuth` here because that would redirect authenticated
    // users away to "/" and strip the `db` query param.
    path: "/subscribe",
    component: () =>
      import(/* webpackChunkName: 'commons' */ "views/Container.vue"),
    meta: { role: ["anyone"] },
    children: [
      {
        name: "qr_subscribe",
        path: "",
        meta: { role: ["anyone"] },
        component: () =>
          import(/* webpackChunkName: 'subscription' */ "views/Subscribe.vue"),
      },
    ],
  },
  {
    path: "/join",
    component: () =>
      import(/* webpackChunkName: 'commons' */ "views/Container.vue"),
    meta: { role: ["doctor", "admin", "superadmin", "local_admin"] },
    children: [
      {
        name: "qr_join",
        path: "",
        meta: { role: ["doctor", "admin", "superadmin", "local_admin"] },
        component: () =>
          import(/* webpackChunkName: 'subscription' */ "views/Join.vue"),
      },
    ],
  },
];

export default routes;
